import React, { useEffect, useState, useContext } from 'react';
import { useParams } from 'react-router-dom';
import {
    Container,
    Box,
    Typography,
    Grid,
    Paper,
    Button,
    CircularProgress,
} from '@mui/material';
import { ConfigContext, http } from '../m34n-ui/src/lib';


export default function OrderSuccess() {
    const { orderId } = useParams();
    const [order, setOrder] = useState(null);
    const [loading, setLoading] = useState(true);
    const [productPrice, setProductPrice] = useState(0);
    const {config} = useContext(ConfigContext);

    useEffect(() => {
        const fetchOrder = async () => {
            try {
                const orderData = await http.get({}, `${config.uri.base}/order/success/${orderId}`);

                // Get the price based on the registration type
                const selectedRegistrationType = orderData.product.registrationTypes.find(
                    (type) => type.type === orderData.registrationType
                );

                setProductPrice(selectedRegistrationType ? selectedRegistrationType.price : 0);
                setOrder(orderData);
            } catch (error) {
                console.error('Failed to fetch order:', error);
            } finally {
                setLoading(false);
            }
        };

        fetchOrder();
    }, [orderId]);

    const renderTile = (label, value) => (
        <Grid item xs={12} sm={6}>
            <Paper elevation={2} sx={{ padding: '16px', margin: '8px' }}>
                <Typography variant="subtitle1"><strong>{label}:</strong></Typography>
                <Typography variant="body1">{value}</Typography>
            </Paper>
        </Grid>
    );

    if (loading) {
        return <CircularProgress />;
    }

    if (!order) {
        return (
            <Container>
                <Typography variant="h6" color="error">
                    Order not found.
                </Typography>
            </Container>
        );
    }

    const shippingPrice = order.selectedShippingOption.cost_excl_tax || 0;

    return (
        <Container>
            <Box sx={{ textAlign: 'center', marginTop: '40px' }}>
                <Typography variant="h4" color="primary" gutterBottom>
                    Order Confirmed
                </Typography>
                <Box sx={{ display: 'flex', justifyContent: 'center' }}>
                <img src={order.product.thumbnailURL} alt={order.product.title} style={{ width: '200px', height: '200px', borderRadius: '50%' }} />
                </Box>
                <Typography variant="h6" sx={{ marginBottom: '20px' }}>
                    Thank you for your order, {order.firstName}! Your order has been successfully processed.
                </Typography>
                <Typography variant="body1" sx={{ marginBottom: '20px' }}>
                You will receive a confirmation email shortly with more details about your order. 
                If you do not see the email in a few minutes, please check your “junk mail” folder or “spam” folder.
                </Typography>
            </Box>

            <Grid container spacing={2} sx={{ marginTop: '20px' }}>
                {renderTile("Order ID", order._id)}
                {renderTile("Registration Type", order.registrationType)}
                {renderTile("Name", `${order.firstName} ${order.lastName}`)}
                {renderTile("Email", order.email)}
                {renderTile("Phone", `${order.phoneCountry} ${order.phone}`)}
                {renderTile("Shipping Address", `${order.shippingAddress}, ${order.shippingCity}, ${order.shippingState} ${order.shippingPostalCode}, ${order.shippingCountry}`)}
                {renderTile("Shipping Method", order.selectedShippingOption.carrier_service_name)}
                {renderTile("Estimated Delivery", `${new Date(order.selectedShippingOption.min_delivery_date).toLocaleDateString()} - ${new Date(order.selectedShippingOption.max_delivery_date).toLocaleDateString()}`)}
            </Grid>

            <Box sx={{ textAlign: 'center', marginTop: '40px' }}>
                <Typography variant="h6" gutterBottom>
                    Order Summary
                </Typography>
                {order.printJob.line_items.map((item, index) => (
                    <Grid container spacing={2} key={index}>
                        {renderTile("Item", item.title)}
                        {renderTile("Quantity", item.quantity)}
                    </Grid>
                ))}
                <Grid container spacing={2} sx={{ marginTop: '20px' }}>
                    {renderTile("Product Price", `$${productPrice.toFixed(2)}`)}
                    {renderTile("Shipping Price", `$${shippingPrice.toFixed(2)}`)}
                </Grid>
                <Grid container spacing={2} sx={{ marginTop: '20px' }}>
                <Grid item xs={12}>
                    <Paper elevation={2} sx={{ padding: '16px', margin: '8px' }}>
                        <Typography variant="subtitle1"><strong>Total Price:</strong></Typography>
                        <Typography variant="h5" color="secondary">
                            ${order.totalPrice ? order.totalPrice.toFixed(2) : 0}
                        </Typography>
                    </Paper>
                </Grid>
            </Grid>
            </Box>
        </Container>
    );
}
